import { useEffect } from "react";
import useForm from "../../hooks/useForm";
import RenderInput from "../../utils/RandarInput";
import { Typography, Box } from "@mui/material";

interface Field {
  id: string;
  title: string;
  placeholder?: string;
  type?: string;
  required?: boolean;
  options?: any[];
  file_type?: string | null;
  error?: boolean;
  helperText?: string;
}

interface VariantFormProps {
  formData: Record<string, any>;
  fields: Field[];
  index: number;
  onFormUpdate: (index: number, formValues: Record<string, any>) => void;
  formsErrors: any;
  removeForm: (index: number) => void;
}

const VariantForm: React.FC<VariantFormProps> = ({ 
  formData, 
  fields, 
  index, 
  onFormUpdate, 
  formsErrors, 
  removeForm 
}) => {
  const { formValues, setFormValues, errors, setErrors } = useForm({
    ...formData,
  });

  useEffect(() => {
    onFormUpdate(index, formValues);
  }, [formValues, index, onFormUpdate]);

  useEffect(() => {
    if (formsErrors[index]) {
      setErrors(formsErrors[index]);
    }
  }, []);

  useEffect(() => {
    if (formsErrors[index]) {
      setErrors(formsErrors[index]);
    }
  }, [formsErrors, index, setErrors]);

  return (
    <div className="mt-5">
      <div className="flex" style={{ justifyContent: "space-between" }}>
        <Typography sx={{ fontWeight: "bold" }}>
          {"Variation " + (index + 1)}
        </Typography>
        <button 
          type="button" 
          className="close" 
          aria-label="Close" 
          onClick={() => removeForm(index)}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      {fields.map((field) => {
        return (
          <RenderInput
            item={{
              ...field,
              type: field.type ?? 'text',
              error: Boolean((errors as any)?.[field.id]),
              helperText: (errors as any)?.[field.id] || "",
            }}
            state={formValues}
            stateHandler={setFormValues}
            key={field.id}
          />
        );
      })}
      <hr className="border-spacing-5" />
    </div>
  );
};

export default VariantForm;